import { Directive } from '@angular/core';
import { Input, OnInit, ViewContainerRef, TemplateRef, OnDestroy } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RoleService } from 'src/app/core/services/role.service';

@Directive({
  selector: '[appIfRoles]'
})
export class IfRolesDirective implements OnInit, OnDestroy {

  private subscription: Subscription[] = [];
  // the role the user must have
  @Input() public appIfRoles: Array<string>;

  /**
   * @param {ViewContainerRef} viewContainerRef -- the location where we need to render the templateRef
   * @param {TemplateRef<any>} templateRef -- the templateRef to be potentially rendered
   * @param {RolesService} rolesService -- will give us access to the roles a user has
   */
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private rolesService: RoleService
  ) {}

  public ngOnInit(): void {
    this.subscription.push(
      // this.rolesService.getRoles().subscribe(res => {
      //   alert('worked roled directivesd')
      //   console.log(res,'worked fines')
      //   if (!res.roles) {
      //     // Remove element from DOM
      //     this.viewContainerRef.clear();
      //   }
      //   // user Role are checked by a Roles mention in


      //   const idx = res.roles.findIndex((element) => this.appIfRoles.indexOf(element) !== -1);
      //   console.log('clalled in direcitves files',this.appIfRoles)
      //   if (idx < 0) {
      //     this.viewContainerRef.clear();
      //   } else {
      //     // appends the ref element to DOM
      //     this.viewContainerRef.createEmbeddedView(this.templateRef);
      //   }
      // })
    );
  }

  /**
   * on destroy cancels the API if its fetching.
   */
  public ngOnDestroy(): void {
    this.subscription.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
}
